// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"632b9fc9","339":"037e836d","400":"266b141a","514":"061d2a99","548":"14987671","806":"c15318d6"}[chunkId] + ".chunk.js";
};